module.exports = __webpack_public_path__ + "img/certificadoM1.191d10e8.png";